export const lockScroll = {
    mounted() {
      document.getElementsByTagName('body')[0].classList.add('lock-scroll');
    },
    destroyed() {
      document.getElementsByTagName('body')[0].classList.remove('lock-scroll');
    },
    methods: {
        printHello() {
            return 'Hello'
        }
    }
};